import React from "react";
import "./App.css";
import Home from "./components/Home";

const App = () => {
  return (
    <div className="h-screen flex flex-col">
      <Home />
    </div>
  );
};

export default App;
